/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmailTokens
 */
export interface EmailTokens {
    /**
     * **Email Token** A token to use in place of an email. The token is only provided after the user has verified their email. This should only have a value if emailExchangeToken does not.
     * @type {string}
     * @memberof EmailTokens
     */
    emailToken?: string;
    /**
     * **Exchange Token** Verifies that this client submitted the email for tokenization.  This should only have a value if emailToken does not.
     * @type {string}
     * @memberof EmailTokens
     */
    exchangeToken?: string;
}

export function EmailTokensFromJSON(json: any): EmailTokens {
    return EmailTokensFromJSONTyped(json, false);
}

export function EmailTokensFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmailTokens {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'emailToken': !exists(json, 'emailToken') ? undefined : json['emailToken'],
        'exchangeToken': !exists(json, 'exchangeToken') ? undefined : json['exchangeToken'],
    };
}

export function EmailTokensToJSON(value?: EmailTokens | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'emailToken': value.emailToken,
        'exchangeToken': value.exchangeToken,
    };
}

